module.exports = __webpack_public_path__ + "img/ELLY_Logo_animated_loop_1_fast.fe57a070.svg";